import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import LocizeBackend from 'i18next-locize-backend';
import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';

const commonOpts = {
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
};

const prodOpts = {
  backend: {
    backends: [HttpBackend],
    backendOptions: [],
  },
};

const devOpts = {
  debug: true,
  saveMissing: true,
  backend: {
    backends: [LocizeBackend, HttpBackend],
    backendOptions: [
      {
        projectId: process.env.REACT_APP_LOCIZE_PROJECT_ID,
        apiKey: process.env.REACT_APP_LOCIZE_API_KEY,
        referenceLng: 'en',
      },
    ],
  },
};

const mergedOpts = {
  ...commonOpts,
  ...(process.env.NODE_ENV === 'production' ? prodOpts : devOpts),
};

i18n
  .use(ChainedBackend)
  .use(initReactI18next)
  .use(I18nextBrowserLanguageDetector)
  .init(mergedOpts, (err, t) => {
    if (err) return console.error(err);
  });

export default i18n;
export const AVAILABLE_LANGS = ['en', 'hi', 'vi', 'ru'];
export const AVAILABLE_REG_SERVER_LANGS = ['en', 'ru'];
export const REG_SERVER_FALLBACK_LANG = 'en';
